import WizardLayout from './WizardLayout';
import { MembershipWizardProvider } from '../context/MembershipWizardContext';
import type { WizardProps } from '../types';

const Wizard = ({ variant, validation, progressBar }: WizardProps) => {
  return (
    <MembershipWizardProvider>
      <WizardLayout
        variant={variant}
        validation={validation}
        progressBar={progressBar}
      />
    </MembershipWizardProvider>
  );
};

export default Wizard;
